<template>
  <div>
    <header class="sm:px-6 lg:px-8">
      <h1 class="text-2xl font-bold leading-tight text-gray-900 mb-0">
        {{ this.$route.name }}
      </h1>
    </header>
    <main>
      <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div class="px-4 py-3 sm:px-0">
          <div class="flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <DataTable
                    :value="users"
                    :paginator="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    :rows="10"
                    :rowsPerPageOptions="[10, 20, 50]"
                    :auto-layout="true"
                    stripedRows
                    class="p-datatable-striped admin-projects-table"
                  >
                    <Column field="id" header="# ID"></Column>
                    <Column field="color" header="AVATAR">
                      <template #body="slotProps">
                        <Avatar
                          :image="avatar_face"
                          shape="circle"
                          class="p-1"
                          :style="{ 'background-color': slotProps.data.color }"
                        />
                      </template>
                    </Column>
                    <Column field="username" header="NOM"></Column>
                    <Column field="email" header="EMAIL"></Column>
                    <Column :exportable="false" style="min-width: 8rem">
                      <template #body="slotProps">
                        <i
                          @click="goToUserDetails(slotProps.data.id)"
                          class="pi pi-eye cursor-pointer p-mr-5 p-mb-2"
                        ></i>
                        <i
                          @click="deleteUser(slotProps.data.id)"
                          class="pi pi-trash cursor-pointer"
                        ></i>
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Avatar from "primevue/avatar";

import avatar_face from "~/assets/img/avatars/face-1.svg";
import { mapGetters } from "vuex";

export default {
  name: "Users",
  components: {
    DataTable,
    Column,
    Avatar,
  },
  mounted() {
    this.$store.dispatch("users/fetchAll");
  },
  data() {
    return {
      avatar_face: avatar_face,
    };
  },
  computed: {
    ...mapGetters("users", {
      users: "getAll",
    }),
  },
  methods: {
    goToUserDetails(idUser) {
      this.$router.push({ name: "Admin User Details", params: { idUser } });
    },
    async deleteUser(idUser) {
      this.$confirm.require({
        message: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
        header: 'Confirmation de suppression',
        icon: 'pi pi-exclamation-triangle',
		acceptLabel: 'Oui',
		rejectLabel: 'Non',
        accept: async () => {
          await this.$store.dispatch('users/delete', idUser)
          this.$toast.add({
            severity:'success', summary: 'Utilisateur supprimé', detail:'L\'utilisateur a été supprimé avec succès', life: 3000
          });
        }
      })
    },
  },
};
</script>

<style scoped></style>
